import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { GetWishlistDtoImpl } from '../../../../core/dto/wishlist/getwishlist/getwishlistdto';
import { GetWishlistResponse } from '../../../../core/api/wishlist/getwishlist/getwishlistresponse';
import { GetWishlistRequestImpl } from '../../../../core/api/wishlist/getwishlist/getwishlistrequest';

export interface WishlistAPIModel extends APIModel
{
    getWishlist(): void;
    getPlaylist(): void;
}

export class WishlistAPIModelImpl extends APIModelImpl implements WishlistAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getWishlist(): void
    {
        let getWishlistDto = new GetWishlistDtoImpl();
        getWishlistDto.setIdentifier("ViewWishListItems");
        getWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        getWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getWishlistDto.setWishlistType("1");

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetWishlist()
        .success((getWishlistResponse: GetWishlistResponse)=>
        {
            getWishlistDto.setWishlistToneDetailsList(getWishlistResponse.getGetWishlistDto().getWishlistToneDetailsList());

            this.getAPIModelHandler().onSuccess(getWishlistResponse.getAPIFeature(), 
            getWishlistResponse.getDescription(), getWishlistDto);
          
         })
        .failure((getWishlistResponse: GetWishlistResponse)=>
         {
           this.getAPIModelHandler().onFailure(getWishlistResponse.getAPIFeature(), 
           getWishlistResponse.getDescription(), undefined);
         })
        .execute(new GetWishlistRequestImpl(getWishlistDto));
    }

    getPlaylist(): void 
    {
        let getWishlistDto = new GetWishlistDtoImpl();
        getWishlistDto.setIdentifier("ViewWishListItems");
        getWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        getWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getWishlistDto.setWishlistType("2");

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetWishlist()
        .success((getWishlistResponse: GetWishlistResponse)=>
        {
            getWishlistDto.setWishlistToneDetailsList(getWishlistResponse.getGetWishlistDto().getWishlistToneDetailsList());

            this.getAPIModelHandler().onSuccess(getWishlistResponse.getAPIFeature(), 
            getWishlistResponse.getDescription(), getWishlistDto);
          
         })
        .failure((getWishlistResponse: GetWishlistResponse)=>
         {
           this.getAPIModelHandler().onFailure(getWishlistResponse.getAPIFeature(), 
           getWishlistResponse.getDescription(), undefined);
         })
        .execute(new GetWishlistRequestImpl(getWishlistDto));
    }
   
    // private getListOfTones()
    // {  let tone1 = new ToneDtoImpl();
    //     tone1.setId("1");
    //     tone1.setToneName("1234rsva");
    //     tone1.setArtistName("987ytrfgbnmk");
    //     tone1.setImgPath("http://placehold.it/120x120&text=image1");
    //     tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone2 = new ToneDtoImpl();
    //     tone2.setId("2");
    //     tone2.setToneName("1234rsva");
    //     tone2.setArtistName("987ytrfgbnmk");
    //     tone2.setImgPath("http://placehold.it/120x120&text=image2");
    //     tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

    //     let tone3 = new ToneDtoImpl();
    //     tone3.setId("3");
    //     tone3.setToneName("1234rsva");
    //     tone3.setArtistName("987ytrfgbnmk");
    //     tone3.setImgPath("http://placehold.it/120x120&text=image3");
    //     tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

    //     let tone4 = new ToneDtoImpl();
    //     tone4.setId("4");
    //     tone4.setToneName("1234rsva");
    //     tone4.setArtistName("987ytrfgbnmk");
    //     tone4.setImgPath("http://placehold.it/120x120&text=image4");
    //     tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone5 = new ToneDtoImpl();
    //     tone5.setId("5");
    //     tone5.setToneName("1234rsva");
    //     tone5.setArtistName("987ytrfgbnmk");
    //     tone5.setImgPath("http://placehold.it/120x120&text=image5");
    //     tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone6 = new ToneDtoImpl();
    //     tone6.setId("6");
    //     tone6.setToneName("1234rsva");
    //     tone6.setArtistName("987ytrfgbnmk");
    //     tone6.setImgPath("http://placehold.it/120x120&text=image6");

    //     let tone7 = new ToneDtoImpl();
    //     tone7.setId("7");
    //     tone7.setToneName("1234rsva");
    //     tone7.setArtistName("987ytrfgbnmk");
    //     tone7.setImgPath("http://placehold.it/120x120&text=image7");

    //     let tone8 = new ToneDtoImpl();
    //     tone8.setId("8");
    //     tone8.setToneName("1234rsva");
    //     tone8.setArtistName("987ytrfgbnmk");
    //     tone8.setImgPath("http://placehold.it/120x120&text=image8");

    //     return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    // }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/wishlistapimodel.ts